module.exports = __webpack_public_path__ + "assets/img/honor3.d4bc25e7.png";